import React from "react";
import { useOutlet } from "react-router";
import useAuthRedirect from "../../hooks/useAuthRedirect"; // update the path as needed

const AuthLayout = () => {
  useAuthRedirect();
  const outlet = useOutlet();
  return <>{outlet}</>;
};

export default AuthLayout;
